/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputStockItem
 */
export interface OutputStockItem {
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputStockItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    type?: string;
}

/**
 * Check if a given object implements the OutputStockItem interface.
 */
export function instanceOfOutputStockItem(value: object): boolean {
    return true;
}

export function OutputStockItemFromJSON(json: any): OutputStockItem {
    return OutputStockItemFromJSONTyped(json, false);
}

export function OutputStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function OutputStockItemToJSON(value?: OutputStockItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
    };
}

